import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { pollSberpayStatus } from "../../submitPayment/methods/sberpay/api/poll.sberpay";
import { isLowerCaseEquals } from "../../../../utils/strings";
import { ESberPaymentStatusConstant } from "../constants";
import { sessionStateMap } from "../persistence/map.dev";
import { clearParams } from "../utils";
export var sberpayStrategy = {
  predicate: function predicate(params) {
    return [Object.keys(params).includes(ESberPaymentStatusConstant.StatusParameter), params[ESberPaymentStatusConstant.State], params[ESberPaymentStatusConstant.OrderIdParameter]].every(Boolean);
  },
  request: function () {
    var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var _ref;
      var status;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            clearParams([ESberPaymentStatusConstant.StatusParameter, ESberPaymentStatusConstant.State, ESberPaymentStatusConstant.OrderIdParameter]);
            status = params[ESberPaymentStatusConstant.State];
            if (!(!status || isLowerCaseEquals(status, ESberPaymentStatusConstant.Failure))) {
              _context.next = 4;
              break;
            }
            throw new Error('unsuccessful status');
          case 4:
            if (isLowerCaseEquals(status, ESberPaymentStatusConstant.Success)) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", undefined);
          case 6:
            return _context.abrupt("return", pollSberpayStatus((_ref = sessionStateMap.sberPayId.load()) !== null && _ref !== void 0 ? _ref : ''));
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function request(_x) {
      return _request.apply(this, arguments);
    }
    return request;
  }()
};